import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Modal } from 'sa-ui';
import messages from './simulatedCorrectionMessages';
import './SimulatedCorrectionProblemsModa.scss';

const SimulatedCorrectionProblemsModal = ({ show, onClose, problems }) => {
  return (
    <Modal
      show={show}
      onClose={onClose}
      icon="ti-alert"
      title={<FormattedMessage {...messages.problemsFound} />}
      buttons={[
        {
          label: <FormattedMessage {...messages.close} />,
          onClick: onClose,
          primary: true,
        },
      ]}
    >
      <div className="problems-content">
        {problems.auditPending && (
          <div className="problem-item">
            <div className="problem-header">
            • <FormattedMessage {...messages.auditPendingTitle} />
            </div>
            <div className="problem-description">
              <FormattedHTMLMessage {...messages.auditRequiredInfo} />
            </div>
          </div>
        )}
        
        {problems.studentsWithoutCards && (
          <div className="problem-item">
            <div className="problem-header">
            • <FormattedMessage {...messages.studentsWithoutCardsTitle} />
            </div>
            <div className="problem-description">
              <FormattedHTMLMessage {...messages.cardsNotLoadedInfo} />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

SimulatedCorrectionProblemsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  problems: PropTypes.shape({
    auditPending: PropTypes.bool,
    studentsWithoutCards: PropTypes.bool,
  }).isRequired,
};

export default SimulatedCorrectionProblemsModal;
